import axios from 'axios';
import FormData from 'form-data';

let api_url= "https://digimail.zendesk.com/";
const token = "1KwtyXzVk1HDHSndHPZlkzxsBj254OI83Y7Yqs0y";

function handleResponse(response) {
    return response;
}

function handleError(error) {
    throw error;
}


export function* getAccessToken() {
    return yield axios
        .get(api_url + "api/v2/users/me.json", {
            Authorization: "Basic "+btoa("kajza.ekblad@digimail.se/token:"+token)
        })
        .then(response => handleResponse(response))
        .catch(error => handleError(error));
}


export function* createRequest(request) {
    return yield axios
        .post(api_url + "api/v2/requests.json", {
            request: request
        }, {
            Authorization: "Basic "+btoa("kajza.ekblad@digimail.se/token:"+token),
            ContentType: "application/json" 
        })
        .then(response => handleResponse(response))
        .catch(error => handleError(error));
}

export function* uploadFile(file) {
    
    const formData = new FormData();
    
    formData.append('data', file);
    
    return yield axios
        .post(api_url + "api/v2/uploads.json?filename="+file.name, formData, {
            'Authorization': "Basic "+btoa("kajza.ekblad@digimail.se/token:"+token),
            'Content-Type': 'application/binary'
        })
        .then(response => handleResponse(response))
        .catch(error => handleError(error));
}



// WEBPACK FOOTER //
// ./src/misc/zendesk.js